import {matchPath} from 'coreUtils/adapters/router';

import routes from 'brand/app/components/LoaderRouter/routes';

import {Route} from './ILoaderRouter';

/**
 * Represents Route Manager
 */
class RouteManager {
	private routes: Array<Route>;
	/**
	 * @constructor
	 */
	constructor() {
		// Load routes from brand level
		this.routes = routes;
	}

	/**
	 * Returns route by action
	 * @param {string} path action
	 * @returns {Route} route
	 */
	getRoute(path: string): Route {
		if (path) {
			for (const route of routes) {
				const match = matchPath(path, {
					path: route.path,
					exact: route.exact,
					strict: route.strict
				});

				if (match) {
					return {...match, ...route};
				}
			}
		} else {
			return this.routes[this.routes.length - 1];
		}
	}
}

export default new RouteManager();
